// TODO hackish sadly
export const Regions = window.regions as any;
